import React, { useState, useRef } from 'react';
import sampleFile from './recargas_ejemplo.xlsx';
import NavbarAdminMex from '../components/navbar';
import './recargasManuales.css';
import * as XLSX from 'xlsx';
import { message as antMessage } from 'antd';
import 'antd/dist/antd.css';

const RecargasManuales = () => {
    const [message, setMessage] = useState('');
    const [excelFile, setExcelFile] = useState(null);
    const [excelData, setExcelData] = useState([]);
    const [uploadLoading, setUploadLoading] = useState(false);
    const fileInputRef = useRef(null);
    
    // Manual recharge state
    const [manualModalVisible, setManualModalVisible] = useState(false);
    const [manualRecharge, setManualRecharge] = useState({
        id_sucursal: '',
        valor: '',
        estado: 'pendiente',
        tipo_recarga: '',
        descripcion: '',
        fecha_recarga: new Date().toISOString().split('T')[0]
    });
    const [comprobante, setComprobante] = useState('');
    const [manualLoading, setManualLoading] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check if file is an Excel file
            const fileType = file.name.split('.').pop().toLowerCase();
            if (fileType === 'xlsx' || fileType === 'xls') {
                setExcelFile(file);
                parseExcelFile(file);
            } else {
                setMessage('Error: El archivo debe ser un archivo Excel (.xlsx o .xls)');
            }
        }
    };

    const parseExcelFile = (file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                // Filter out empty rows
                const filteredData = jsonData.filter(row => 
                    Object.values(row).some(value => 
                        value !== undefined && 
                        value !== null && 
                        value.toString().trim() !== ''
                    )
                );
                
                setExcelData(filteredData);
            } catch (error) {
                console.error('Error parsing Excel file:', error);
                setMessage('Error: No se pudo procesar el archivo Excel');
            }
        };
        reader.readAsBinaryString(file);
    };

    const handleUploadExcel = async () => {
        if (!excelFile) {
            setMessage('Error: Por favor seleccione un archivo Excel');
            antMessage.error('Por favor seleccione un archivo Excel');
            return;
        }

        setUploadLoading(true);
        try {
            const userId = localStorage.getItem('usuario_id');
            const formData = new FormData();
            formData.append('archivo_excel', excelFile);

            const response = await fetch(`https://api.99envios.app/api/online/recargas/crear-recargas-excel/${userId}`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();
            if (!response.ok) throw new Error('Error al cargar el archivo Excel');

            const successMessage = data.success || 'Archivo Excel procesado exitosamente';
            setMessage(successMessage);
            antMessage.success(successMessage);
            setExcelFile(null);
            setExcelData([]);
        } catch (error) {
            const errorMessage = 'Error: ' + error.message;
            setMessage(errorMessage);
            antMessage.error(errorMessage);
        } finally {
            setUploadLoading(false);
        }
    };

    const handleManualInputChange = (e) => {
        const { name, value } = e.target;
        setManualRecharge({
            ...manualRecharge,
            [name]: value
        });
    };

    const handleComprobanteChange = (e) => {
        setComprobante(e.target.value);
    };

    const handleManualRechargeSubmit = async (e) => {
        e.preventDefault();
        
        if (!manualRecharge.id_sucursal || !manualRecharge.valor || !manualRecharge.tipo_recarga) {
            setMessage('Error: Todos los campos obligatorios deben ser completados');
            return;
        }

        setManualLoading(true);
        try {
            const userId = localStorage.getItem('usuario_id');
            const formData = new FormData();
            
            // Add all form fields to formData
            Object.keys(manualRecharge).forEach(key => {
                formData.append(key, manualRecharge[key]);
            });
            
            // Add comprobante if it has a value
            if (comprobante) {
                formData.append('comprobante', comprobante);
            }
            
            const response = await fetch(`https://api.99envios.app/api/online/recargas/crear-recarga-manual/${userId}`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();
            if (!response.ok) throw new Error('Error al crear la recarga manual');

            setMessage(data.success || 'Recarga manual creada exitosamente');
            setManualModalVisible(false);
            setManualRecharge({
                id_sucursal: '',
                valor: '',
                estado: 'pendiente',
                tipo_recarga: '',
                descripcion: '',
                fecha_recarga: new Date().toISOString().split('T')[0]
            });
            setComprobante('');
        } catch (error) {
            setMessage('Error: ' + error.message);
        } finally {
            setManualLoading(false);
        }
    };

    // Create table columns based on the first row of data
    const getTableColumns = () => {
        if (excelData.length === 0) return [];
        
        const firstRow = excelData[0];
        return Object.keys(firstRow).map(key => ({
            title: key.toUpperCase(),
            dataIndex: key,
            key: key,
            render: (text) => text !== undefined ? text.toString() : '',
        }));
    };

    return (
        <>
        <NavbarAdminMex title={"Recargas Manuales"} />
        <div className="recargas-manuales-container">
            <h2>Gestión de Recargas</h2>

            <div className="recargas-actions-container">
                <button 
                    className="recargas-button manual-recharge"
                    onClick={() => setManualModalVisible(true)}
                >
                    Recarga Manual
                </button>
                
                <input 
                    type="file" 
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept=".xlsx, .xls" 
                    onChange={handleFileChange} 
                />
                
                <button 
                    className="recargas-button upload-excel"
                    onClick={() => fileInputRef.current.click()}
                >
                    Cargar Excel
                </button>
                
                <a 
                    href={sampleFile} 
                    download="recargas_ejemplo.xlsx"
                    className="recargas-button download-template"
                >
                    Descargar Plantilla
                </a>
                
                {excelFile && (
                    <button 
                        className="recargas-button submit-excel"
                        onClick={handleUploadExcel}
                        disabled={uploadLoading}
                    >
                        {uploadLoading ? 'Enviando...' : 'Enviar Excel'}
                    </button>
                )}
            </div>
            
            {excelFile && (
                <div className="file-info">
                    <p>Archivo seleccionado: <strong>{excelFile.name}</strong></p>
                </div>
            )}
            
            {excelData.length > 0 && (
                <div className="excel-data-table-container">
                    <h3>Datos del Archivo Excel</h3>
                    <div className="excel-data-table">
                        <table>
                            <thead>
                                <tr>
                                    {getTableColumns().map(column => (
                                        <th key={column.key}>{column.title}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {excelData.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {getTableColumns().map(column => (
                                            <td key={`${rowIndex}-${column.key}`}>
                                                {row[column.dataIndex] !== undefined 
                                                    ? row[column.dataIndex].toString() 
                                                    : ''}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* Manual Recharge Modal */}
            {manualModalVisible && (
                <div className="modal-overlay">
                    <div className="modal-content-recarga-manual manual-recharge-modal">
                        <button 
                            className="modal-close-btn"
                            onClick={() => {
                                setManualModalVisible(false);
                                setComprobante('');
                                setManualRecharge({
                                    id_sucursal: '',
                                    valor: '',
                                    estado: 'pendiente',
                                    tipo_recarga: '',
                                    descripcion: '',
                                    fecha_recarga: new Date().toISOString().split('T')[0]
                                });
                            }}
                        >
                            ×
                        </button>
                        <h3>Crear Recarga Manual</h3>
                        <form onSubmit={handleManualRechargeSubmit} className="manual-recharge-form">
                            <div className="form-group-recarga-manual">
                                <label htmlFor="id_sucursal">ID Sucursal*:</label>
                                <input
                                    type="text"
                                    id="id_sucursal"
                                    name="id_sucursal"
                                    value={manualRecharge.id_sucursal}
                                    onChange={handleManualInputChange}
                                    required
                                    className="form-control"
                                />
                            </div>
                            
                            <div className="form-group-recarga-manual">
                                <label htmlFor="valor">Valor*:</label>
                                <input
                                    type="number"
                                    id="valor"
                                    name="valor"
                                    value={manualRecharge.valor}
                                    onChange={handleManualInputChange}
                                    required
                                    className="form-control"
                                    min="0"
                                    step="0.01"
                                />
                            </div>
                            
                            <div className="form-group-recarga-manual">
                                <label htmlFor="estado">Estado:</label>
                                <select
                                    id="estado"
                                    name="estado"
                                    value={manualRecharge.estado}
                                    onChange={handleManualInputChange}
                                    className="form-control"
                                >
                                    <option value="pendiente">Pendiente</option>
                                    <option value="aprobada">Aprobada</option>
                                    <option value="rechazada">Rechazada</option>
                                </select>
                            </div>
                            
                            <div className="form-group-recarga-manual">
                                <label htmlFor="comprobante">Comprobante:</label>
                                <input
                                    type="text"
                                    id="comprobante"
                                    name="comprobante"
                                    value={comprobante}
                                    onChange={handleComprobanteChange}
                                    className="form-control"
                                />
                            </div>
                            
                            <div className="form-group-recarga-manual">
                                <label htmlFor="tipo_recarga">Tipo Recarga*:</label>
                                <input
                                    type="text"
                                    id="tipo_recarga"
                                    name="tipo_recarga"
                                    value={manualRecharge.tipo_recarga}
                                    onChange={handleManualInputChange}
                                    required
                                    className="form-control"
                                />
                            </div>
                            
                            <div className="form-group-recarga-manual">
                                <label htmlFor="descripcion">Descripción:</label>
                                <textarea
                                    id="descripcion"
                                    name="descripcion"
                                    value={manualRecharge.descripcion}
                                    onChange={handleManualInputChange}
                                    className="form-control"
                                    rows="3"
                                ></textarea>
                            </div>
                            
                            <div className="form-group-recarga-manual">
                                <label htmlFor="fecha_recarga">Fecha Recarga:</label>
                                <input
                                    type="date"
                                    id="fecha_recarga"
                                    name="fecha_recarga"
                                    value={manualRecharge.fecha_recarga}
                                    onChange={handleManualInputChange}
                                    className="form-control"
                                />
                            </div>
                            
                            <div className="modal-footer">
                                <button 
                                    type="button"
                                    className="recargas-button cancel"
                                    onClick={() => {
                                        setManualModalVisible(false);
                                        setComprobante('');
                                        setManualRecharge({
                                            id_sucursal: '',
                                            valor: '',
                                            estado: 'pendiente',
                                            tipo_recarga: '',
                                            descripcion: '',
                                            fecha_recarga: new Date().toISOString().split('T')[0]
                                        });
                                    }}
                                    disabled={manualLoading}
                                >
                                    Cancelar
                                </button>
                                <button 
                                    type="submit"
                                    className="recargas-button submit"
                                    disabled={manualLoading}
                                >
                                    {manualLoading ? 'Guardando...' : 'Guardar Recarga'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
        </>
    );
};

export default RecargasManuales;
